import Draft from "draft-js";
import { getEntitySelections } from "./getEntitySelections";

/**
 * Remove entity from editor content, maintaining user selection
 */
export const removeEntity = (
  editorState: Draft.EditorState,
  entityKey: string | null,
) => {
  if (!entityKey) return editorState;

  const content = editorState.getCurrentContent();
  const userSelection = editorState.getSelection();
  const entitySelections = getEntitySelections(content, entityKey);

  // Remove entity from the selection within content
  const nextContent = entitySelections.reduce(
    (intermediateContent, selection) =>
      Draft.Modifier.applyEntity(intermediateContent, selection, null),
    content,
  );

  // Update editor state, preserving user selection
  return Draft.EditorState.forceSelection(
    Draft.EditorState.push(editorState, nextContent, "apply-entity"),
    userSelection,
  );
};
